<script>
import { ActionBar, ActionBarTitle } from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { WarehouseService } from '@/services'

import Overview from './Overview'
import Filter from './Filter'
import Result from './Result'

export default {
  data() {
    const { query } = this.$route

    return {
      overview: {
        totalWeight: 0,
        ticketAmount: 0,
        isLoading: false
      },
      filter: {
        q: query.q || '',
        type: query.type || '',
        page: Number(query.page) || 1
      },
      result: {
        items: [],
        pagination: {
          page: 1,
          total: 0,
          pageSize: 10
        },
        isLoading: false
      }
    }
  },

  created() {
    this.fetchOverview()
    this.fetchResult()
  },

  methods: {
    async fetchOverview() {
      this.overview.isLoading = true

      try {
        const {
          data: { result }
        } = await WarehouseService.pawn.getOverview()

        this.overview = {
          ...this.overview,
          totalWeight: result.remaining_amount,
          ticketAmount: result.pawn_ticket_count
        }
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.overview.isLoading = false
      }
    },

    async fetchResult() {
      this.result.isLoading = true

      try {
        const {
          data: { result }
        } = await WarehouseService.pawn.getAll({
          search: this.filter.q || undefined,
          type: this.filter.type || undefined,
          page: this.result.pagination.page
        })

        const { results, count } = result

        this.result.items = results.map((item, index) => ({
          index: index + 1,
          id: item.id,
          name: item.used_product ? item.used_product.name : '',
          ticketAmount: item.pawn_ticket_count,
          totalWeight: +item.remaining_amount,
          productId: item.used_product ? item.used_product.id : null
        }))

        this.result.pagination = { ...this.result.pagination, total: count }
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.result.isLoading = false
      }
    },

    handleFilterSubmit() {
      this.filter.page = 1

      this.$router.replace({
        query: {
          q: this.filter.q || undefined,
          type: this.filter.type || undefined
        }
      })

      this.fetchResult()
    },

    handleResultPageChange(page) {
      this.filter.page = page

      this.$router.replace({ query: { ...this.$route.query, page } })

      this.fetchResult()
    },

    handleResultView(id, productId) {
      this.$router.push({
        name: 'WarehousePawnDetail',
        params: { id, productId }
      })
    }
  },

  render() {
    return (
      <div>
        <ActionBar>
          <ActionBarTitle>คลังสินค้า ทองขายฝาก</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Overview
              totalWeight={this.overview.totalWeight}
              ticketAmount={this.overview.ticketAmount}
              loading={this.overview.isLoading}
            />
            <Filter
              q={this.filter.q}
              type={this.filter.type}
              style={{ marginTop: '1.5rem' }}
              on={{
                'update:q': value => {
                  this.filter.q = value
                },
                'update:type': value => {
                  this.filter.type = value
                },
                submit: this.handleFilterSubmit
              }}
            />
            <Result
              items={this.result.items}
              pagination={this.result.pagination}
              loading={this.result.isLoading}
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.handleResultPageChange}
              onView={this.handleResultView}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
